const commonStyle = {
  common: {
    background: "#C1D8FC",
    font: "#052962"
  }
};
const subscriptionStyles = {
  commercial: {
    background: "#77EEAA",
    font: "#004400"
  },
  cmp: {
    background: "#FF6BB5",
    font: "#2F0404"
  },
  dotcom: {
    background: "#000000",
    font: "#ff7300"
  },
  design: {
    background: "#185E36",
    font: "#FFF4F2"
  },
  tx: {
    background: "#2F4F4F",
    font: "#FFFFFF"
  },
  supporterRevenue: {
    background: "#0F70B7",
    font: "#ffffff"
  },
  identity: {
    background: "#6F5F8F",
    font: "#ffffff"
  },
  openJournalism: {
    background: "#C74600",
    font: "#FEF9F5"
  },
  perf: {
    background: "#FFD700",
    font: "#000000"
  }
};
const isSubscription = (subscription) => Object.keys(subscriptionStyles).includes(subscription);

export { commonStyle, isSubscription, subscriptionStyles };
